import { Component, OnInit } from '@angular/core';
import { ReportService } from '../shared/report-service';
import { DataDictionaryTableDto } from '../shared/dto/data-dictionary-table.dto';
import { SelectItem } from 'primeng/api';
import { DataDictionaryTableColumnDto } from '../shared/dto/data-dictionary-table-column.dto';

@Component({
  selector: 'wl-data-dictionary',
  templateUrl: './data-dictionary.component.html',
  styleUrls: ['./data-dictionary.component.less'],
    standalone: false
})
export class DataDictionaryComponent implements OnInit {
  private selectedIds: number[] = [];

  public allTables: SelectItem[] = [];
  public selectedTable: number;
  public selectedTables: string[] = [];
  public tableResults: DataDictionaryTableColumnDto[] = [];
  public tableSearchResult: string[] = [];
  public isSearching = false;

  public constructor(private _reportService: ReportService) {}

  ngOnInit() {
    this._reportService.getDbTableList().then((data) => {
      this.allTables = data.map((x) => {
        return { label: x.TableName, value: x.ObjectId };
      });
    });
  }

  public addTableToList() {
    let selectedDto = this.allTables.filter((x) => x.value === this.selectedTable)[0];

    this.selectedIds.push(selectedDto.value);
    this.selectedTables = [...this.selectedTables, selectedDto.label];

    this.search();
  }

  public removeTableFromList() {
    this.selectedIds = this.allTables.filter((x) => this.selectedTables.includes(x.label)).map((x) => x.value);

    this.isSearching = true;
    this.search();
  }

  searchTables(event: any) {
    this.tableSearchResult = this.allTables.filter((x) => x.label.toLowerCase().includes(event.query.toLowerCase())).map((x) => x.label);
  }

  public search() {
    this.isSearching = true;

    const tableIds = this.allTables.filter((x) => this.selectedTables.includes(x.label)).map((x) => x.value);

    this._reportService
      .getDbTableColumns(tableIds)
      .then((data) => {
        this.tableResults = data;
      })
      .finally(() => {
        this.isSearching = false;
      });
  }
}
